import EmprestimoUniforme, {
  FinderEmprestimosUniforme,
  RetornoEmprestimoUniforme,
} from 'Interface/EmprestimosUniforme';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { paramsParaString, formData } from '../utils';

const tag = 'EmprestimosUniforme';

const url = '/emprestimos-uniforme';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarEmprestimosUniforme: construtor.query<
        FinderEmprestimosUniforme,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.emprestimos
            ? [
                ...resultado.emprestimos.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarEmprestimoUniforme: construtor.query<
        RetornoEmprestimoUniforme,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarEmprestimoUniforme: construtor.mutation<
        RetornoEmprestimoUniforme,
        Partial<EmprestimoUniforme>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarEmprestimoUniforme: construtor.mutation<
        RetornoEmprestimoUniforme,
        Partial<EmprestimoUniforme> & Pick<EmprestimoUniforme, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerEmprestimoUniforme: construtor.mutation<
        RetornoEmprestimoUniforme,
        Partial<EmprestimoUniforme> & Pick<EmprestimoUniforme, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarEmprestimosUniformeQuery,
  useRecuperarEmprestimoUniformeQuery,
  useAdicionarEmprestimoUniformeMutation,
  useEditarEmprestimoUniformeMutation,
  useRemoverEmprestimoUniformeMutation,
} = apiExtendida;
